export default __webpack_public_path__ + "static/media/picturePlaceHolder.48ca1f4b.png";